import { Box, Flex } from '@chakra-ui/react'
import { motion } from 'framer-motion'

const MotionBox = motion(Box)
const MotionFlex = motion(Flex)

export {MotionFlex}
export default MotionBox